import {
  Box,
  Dialog,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import { CommonApi } from "src/api/CommonApi";

function MasterTable({ openMaster, handleCloseMaster, setTable, selectedRow }) {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [highlightIndex, setHighlightIndex] = useState(0);

  const inputRef = useRef();
  const rowRefs = useRef([]);


  useEffect(() => {
    if (openMaster) {
      setSearch("");
      fetchData("");
      setHighlightIndex(0);

      setTimeout(() => {
        inputRef.current?.focus();
      }, 200);
    }
  }, [openMaster]);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchData(search);
    }, 400);

    return () => clearTimeout(delay);
  }, [search]);

  const fetchData = async (searchText = "") => {
    try {
      const res = await CommonApi.getMasterList({
        page: 1,
        count: 20,
        search: searchText,
      });

      if (res?.success) {
        setRows(res.data || []);
        setHighlightIndex(0);
      }
    } catch (err) {
      console.log(err);
    }
  };


  useEffect(() => {
    rowRefs.current[highlightIndex]?.scrollIntoView({
      block: "nearest",
    });
  }, [highlightIndex]);


  const handleSelect = (row) => {
    setTable((prev) => {
      const updated = [...prev];

      updated[selectedRow] = {
        ...updated[selectedRow],
        account_id: row.id,
        account_name: row.label,
        under: row.Typ,
        division: row.division,
        balance: row.balance,
      };

      return updated;
    });

    handleCloseMaster();
  };


  const handleKeyDown = (e) => {
    if (!rows.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightIndex((prev) => (prev < rows.length - 1 ? prev + 1 : prev));
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightIndex((prev) => (prev > 0 ? prev - 1 : prev));
    }

    if (e.key === "Enter") {
      e.preventDefault();
      const selected = rows[highlightIndex];
      if (selected) handleSelect(selected);
    }
  };

  return (
    <Dialog
      open={openMaster}
      onClose={handleCloseMaster}
      fullWidth
      maxWidth="xs"
    >
      <Box p={2}>
        {/* 🔍 SEARCH */}
        <TextField
          label="Search"
          fullWidth
          inputRef={inputRef}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={handleKeyDown}
        />

        <Table sx={{ mt: 2 }}>
          <TableHead>
            <TableRow
              sx={{
                bgcolor: "#324537",
                "& th": {
                  color: "#FFF",
                },
              }}
            >
             {/* <TableCell>ID</TableCell> */}
              <TableCell>Account Name</TableCell>
              <TableCell>Under</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, index) => (
                <TableRow
                  key={row.id}
                  ref={(el) => (rowRefs.current[index] = el)}
                  selected={index === highlightIndex}
                  hover
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleSelect(row)}
                >
                   {/* <TableCell>{row.id}</TableCell> */}
                  <TableCell>{row.label}</TableCell>
                  <TableCell>{row.Typ}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                {/* <TableCell colSpan={3} align="center"> */}
                <TableCell colSpan={2} align="center">
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
    </Dialog>
  );
}

MasterTable.propTypes = {
  openMaster: PropTypes.bool,
  handleCloseMaster: PropTypes.func,
  setTable: PropTypes.func,
  selectedRow: PropTypes.number, // 🔥 important
};

export default MasterTable;
